<template>
        <b-modal :title="caption" class="modal-danger" v-model="dataShow" @ok="confirmTrash" :ok-title="window.Core.Definition.getDefinition('Supprimer')" ok-variant="danger" :cancel-title="window.Core.Definition.getDefinition('Annuler')" cancel-variant="light">
            <Request
                    ref="request"
                    method="DELETE"
                    :root="root"
                    :onRequestSuccess="requestSuccess"
                    :onRequestError="requestError">
                <slot slot="body">
                    <p>
                        {{message}}
                    </p>
                </slot>
            </Request>
        </b-modal>
</template>

<script>
    import Request from './Request'
  export default {
      name: 'ModalTrash',
      components: {
          Request
      },
      props: {
          caption: {
              type: String,
              default: ''
          },
          message: {
              type: String,
              default: ''
          },
          root: {
              type: String,
              default: ''
          }
      },
      watch: {
      },
      mounted() {
      },
      data: () => {
          return {
              window: window,
              dataShow: false,
              dataId: '',
              dataAlert: {
                  message: '',
                  variant: '',
                  show: false
              }
          }
      },
      methods: {
          open(id) {
              this.dataId = id
              this.dataShow = true
          },
          confirmTrash(e) {
              e.preventDefault()
              this.$refs.request.addArg('id', this.dataId)
              this.$refs.request.request()
          },
          requestSuccess(data) {
              if (data.alert !== undefined) {
                  this.dataAlert = data.alert
              } else {
                  this.$refs.request.clearArgs()
                  this.$emit('onTrashSuccess',this.dataId)
                  this.dataShow = false
              }
          },
          requestError() {

          }
      }
  }
</script>